import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parsePostaSearch } from '@/modules/posta/helpers';

const PostaDetail = lazy(() =>
  import('@/modules/posta/PostaDetail').then((m) => ({ default: m.PostaDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/posta/$id',
  component: () => (
    <Suspense fallback={null}>
      <PostaDetail />
    </Suspense>
  ),
  validateSearch: parsePostaSearch,
});
